module.exports = __webpack_public_path__ + "static/15-img-1-ca01bcca18752c369caade4c573fce0a.png";